import { Card, Form, Input, Title } from 'components/common'
import config from 'config'

export interface ProductInventoryProps {
  inventory?: number
  loading?: boolean
}

export const ProductInventory = ({
  inventory,
  loading = false,
}: ProductInventoryProps): JSX.Element => (
  <Card shadow loading={loading}>
    <Title level={5}>在庫</Title>

    <div style={{ width: '50%' }}>
      <Form.Item
        label="数量"
        name={'inventory'}
        initialValue={inventory}
        rules={[
          { required: true, message: '在庫は必須です。' },
          {
            type: 'number',
            min: 0,
            max: config.product.maxInventory,
            message: `0 以上 ${config.product.maxInventory} 以下の数値を入力してください。`,
            transform: (v) => Number(v),
          },
        ]}
      >
        <Input type="number" />
      </Form.Item>
    </div>
  </Card>
)
